import axios from 'axios';
import fileDownload from 'js-file-download';
import fileName from '../utils/fileName';

export const getAutomationUsers = async (userStore) => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}automation/user-list`, {
    headers: {
      Authorization: `${userStore.token}`
    }
  });

  return response.data;
};

export const createFilters = async (userStore, filters) => {
  const response = await axios.post(`${process.env.REACT_APP_API_URL}automation/create-user-filter`, filters, {
    headers: {
      Authorization: `${userStore.token}`
    }
  });

  return response.data;
};

export const createActions = async (userStore, actions) => {
  const response = await axios.post(`${process.env.REACT_APP_API_URL}automation/create-actions`, actions, {
    headers: {
      Authorization: `${userStore.token}`
    }
  });

  return response.data;
};

export const createActionsPush = async (userStore, pushAction) => {
  const response = await axios.post(`${process.env.REACT_APP_API_URL}automation/create-actions-push`, pushAction, {
    headers: {
      Authorization: `${userStore.token}`
    }
  });

  return response.data;
}

export const createSchedule = async (userStore, schedule) => {
  const response = await axios.post(`${process.env.REACT_APP_API_URL}automation/create-schedule`, schedule, {
    headers: {
      Authorization: `${userStore.token}`
    }
  });

  return response.data;
};

export const automationReport = async (userStore, automationId) => {
  console.log(userStore.token, automationId);
  return axios.get(`${process.env.REACT_APP_API_URL}automation/report/${automationId}`, {
    headers: {
      Authorization: `${userStore.token}`
    },
    responseType: 'blob'
  });
};

export const automationList = async (userStore) => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}automation/list`, {
    headers: {
      Authorization: `${userStore.token}`
    }
  });

  return response.data;
};

export const getAutomationReport = async (userStore, automationId, onSuccess, onError) => {
  try {
    const data = await automationReport(userStore, automationId);
    const filename = fileName(data);

    fileDownload(data.data, filename);
    if (onSuccess) {
      onSuccess();
    }
  } catch (e) {
    if (onError) {
      onError();
    }
  }
};
